
import { mapActions, mapState, mapGetters } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: false,
    categoryProp: {
      type: Object,
      default: () => {}
    },
    subCategoryProp: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      loading: false,
      subCategory: {},
      hasSubCategory: false,
      SUB_CATEGORY_ITEM: {
        subcategory_name: "",
        subcategory_description: ""
        // subcategories: []
      },
      valid: false
    };
  },
  computed: {
    ...mapGetters("menu", ["getSubCategoryObj"]),
    isNew() {
      return !(this.subCategoryProp && this.subCategoryProp.id);
    }
  },
  watch: {},
  beforeMount() {
    this.subCategory = this.isNew
      ? this.SUB_CATEGORY_ITEM
      : JSON.parse(JSON.stringify(this.subCategoryProp));
  },
  mounted() {
    // this.subCategory = this.isNew
    //   ? this.SUB_CATEGORY_ITEM
    //   : JSON.parse(
    //       JSON.stringify(this.getSubCategoryObj(this.subCategoryProp.id))
    //     );
    this.$refs.form.resetValidation();
  },
  methods: {
    ...mapActions("menu", [
      "createSubCategory",
      "updateSubCategory",
      "getCategories"
    ]),
    handleSubmit() {
      if (this.isNew) {
        this.handleCreateSubCategory();
      } else {
        this.handleUpdateSubCategory();
      }
    },
    handleCreateSubCategory() {
      this.loading = true;
      this.createSubCategory({
        payload: {
          category_id: this.categoryProp.id,
          ...this.subCategory
        }
      })
        .then((res) => {
          this.getCategories({ forceFetch: true });
          this.$nuxt.$emit("show-toast", {
            text: "Item created successfully",
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.$emit("move-to-subcategory", res?.sub_category?.id);
          this.$emit("close-dialog");
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
          this.loading = false;
        });
    },
    handleUpdateSubCategory() {
      this.loading = true;
      this.updateSubCategory({
        payload: { category_id: this.categoryProp.id, ...this.subCategory }
      })
        .then((res) => {
          this.getCategories({ forceFetch: true });
          this.$nuxt.$emit("show-toast", {
            text: "Item updated successfully",
            color: "success darken-2",
            icon: "done",
            flat: true
          });
          this.$emit("close-dialog");
        })
        .catch((errr) => {
          this.$nuxt.$emit("show-error-toast", errr);
          this.loading = false;
        });
    },
    validate() {
      this.valid = this.$refs.form.validate();
    }
  }
};
